<template>
  <div class="UXpagination">
    <ul v-show="init">
      <li class="iconBtn leftBtn" :class="{out: value === 1}"><a @click="changePage('FIRST')"><i class="UXicon-arrow_left_double"></i></a></li>
      <li class="iconBtn leftBtn" :class="{out: pagCount === 0}"><a @click="beforePage"><i class="UXicon-arrow_left"></i></a></li>
      <li v-for="(item, index) in pagArr" :key="index" :class="{on: pagNumber(index) === value}"><a @click="$emit('input', pagNumber(index))">{{ pagNumber(index) }}</a></li>
      <li class="iconBtn ritBtn" :class="{out: pagCount === maxPaging}"><a @click="nextPage"><i class="UXicon-arrow_right"></i></a></li>
      <li class="iconBtn ritBtn nudgeLeft" :class="{out: value === length || length === size}"><a @click="changePage('LAST')"><i class="UXicon-arrow_right_double"></i></a></li>
    </ul>
    <input type="hidden" v-model="value" />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  data () {
    return {
      pagArr: 0,
      pagCount: 0,
      size: 10,
      maxPaging: 0,
      init: false
    }
  },
  watch: {
    value (val) {
      this.init = val && this.length
    },
    length (val) {
      try {
        this.init = val
        let size = this.length > this.size ? this.size : this.length
        this.pagCount = 0
        this.pagArr = new Array(size)
        this.maxPaging = Math.ceil(this.length / this.size) - 1
      } catch (e) {
        console.log(e)
      }
    }
  },
  props: ['value', 'length'],
  methods: {
    pagNumber (num) {
      return (this.pagCount * this.size) + (num + 1)
    },
    changePage (key) {
      if (key === 'FIRST') {
        if (this.value === 1) {
          return false
        }
        let size = this.length > 10 ? 10 : this.length
        this.pagCount = 0
        this.pagArr = new Array(size)
        this.$emit('input', 1)
      } else if (key === 'LAST') {
        if (this.value === this.length || this.length === this.size) {
          return false
        }
        let totalPages = this.length.toString()
        let size = Number(totalPages.charAt(totalPages.length - 1))
        this.pagCount = this.maxPaging
        this.pagArr = new Array(Number(size || 10))
        this.$emit('input', this.length)
      }
    },
    nextPage () {
      if (this.pagCount === this.maxPaging) {
        return false
      }
      this.pagCount = this.pagCount + 1
      this.$emit('input', (this.pagCount * 10) + 1)
      if (this.maxPaging === this.pagCount) {
        let totalPages = this.length.toString()
        let size = Number(totalPages.charAt(totalPages.length - 1))
        this.pagArr = new Array(Number(size || 10))
        return false
      }
    },
    beforePage () {
      if (this.pagCount === 0) {
        return false
      }
      this.pagArr = new Array(10)
      this.pagCount = this.pagCount - 1
      this.$emit('input', (this.pagCount * 10) + 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue